import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';

import 'bootstrap/dist/css/bootstrap.min.css';
// import "video-react/dist/video-react.css"

import 'core-js/modules/es6.array.find';
import 'core-js/modules/es7.array.includes';
import 'core-js/fn/array';

import '@babel/polyfill';

import 'core-js/fn/array';
import 'core-js/es6/object';
import 'core-js/es7/object';
import 'core-js/es6/set';
import 'core-js/es6/map';
import 'core-js/es6/string';
import 'core-js/es6/array';
import 'core-js/es7/array';

import App from './App';
import config from './data/config';

ReactGA.initialize(config.ga, { debug: (process.env.NODE_ENV !== 'production') });
ReactGA.pageview(window.location.pathname + window.location.search);

ReactDOM.render(<App />, document.getElementById('root'));
